require([
    'underscore',
    'bluebird',
    'jquery',
    'common/container/CommonContainer',
    'core/platformValidation',
    'container/argResolvers/PlatformValidationRuleArgResolver',
    'config/composition',
    'config/extensions/nativeComposition',
    'gameInterfaces/gameInterfacesComposition'
], function (
    _,
    Promise,
    $,
    CommonContainer,
    platformValidation,
    PlatformValidationRuleArgResolver,
    composition,
    nativeComposition,
    gameInterfacesComposition
) {

    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/offline-service-worker.js').then(function () {
            // `registration` provided as first argument
            // Registration was successful
        }).catch(function () {
            // `error` provided as first argument
            // registration failed :(
        });
    }

    $.ajax('/api/common/handshake' + (window.location.search || '')).then(function (handshake) {

        var container,
            modules = ['overlayGameLauncher'].map(function (moduleName) {
                return 'features/' + moduleName + '/module';
            });

        function registerDependencies (features) {
            _(features).forEach(function (feature) {
                feature.registerDependencies();
            });
        }

        function startApp () {

            var logger;

            function handleErrors (e) {
                logger.error('App Error', e.message || e);
                logger.error(e.stack);
            }

            function initialize (app) {
                return app();
            }

            return container.get('Logger').then(
                function (Logger) {

                    logger = new Logger('main');

                    return container.get('app').then(initialize).then(null, handleErrors);
                }
            );
        }

        function bootstrap (resolve, reject) {
            require(
                modules,
                function () {

                    registerDependencies(arguments);

                    container = new CommonContainer(
                        [
                            new PlatformValidationRuleArgResolver(
                                'PlatformValidation',
                                platformValidation.createValidityRule,
                                'PlatformCommandDispatcherAPlus'
                            )
                        ],
                        $.extend(
                            true,
                            {},
                            window.location.href.indexOf('/gameInterfaces/') !== -1
                                ? gameInterfacesComposition
                                : composition.get(),
                            window.native ? nativeComposition : {},
                            {
                                params: {
                                    contextConfiguration: {
                                        targetDevice: 'mobile'
                                    }
                                }
                            }
                        ),
                        handshake
                    );

                    resolve(startApp());
                },
                reject
            );
        }

        return new Promise(bootstrap);
    });

});

define("main", function(){});

